import Activity from '../../schema/Activity';
import ActivityType from '../../schema/innerSchema/ActivityType';
import ActivityTypeNames from '../../schema/innerSchema/ActivityTypeNames';
import CalendarEventOmissionNames from '../../schema/innerSchema/CalendarEventOmissionNames';
import CalendarEventOmission from '../../schema/innerSchema/CalendarEventOmission';
import RoleNames from '../../schema/innerSchema/RoleNames';

/**
 * create Activity item based on the type
 */
export default function createActivityItem(activity: any, activityId: number): Activity {
    let activityTypeBlob = activity.type ? activity.type.toLowerCase() : null;
    let activityType = ActivityTypeNames[activityTypeBlob];
    if (activityType) {
        return createActivity(activity, activityType, activityTypeBlob, activityId);
    } else {
        return null;
    }
}

/**
 * parse the data into Activity item
 */
function createActivity(
    activity: any,
    activityType: ActivityType,
    activityName: string,
    activityId: number
): Activity {
    // check if the properties in the blob - lowercase and save
    let eventOmissionBlob = activity.calendarEventOmission
        ? activity.calendarEventOmission.toLowerCase()
        : null;
    let roleBlob = activity.role ? activity.role.toLowerCase() : null;
    // create objects for the activity
    let activityEventOmission: CalendarEventOmission =
        CalendarEventOmissionNames[eventOmissionBlob];
    let activityRole = RoleNames[roleBlob];

    return {
        activityId: activityId.toString(),
        type: activityType,
        entityId: activity.entityId,
        calendarEventIdIndex: activity.calendarEventIdIndex,
        eventOmission: activityEventOmission,
        role: activityRole,
        activityName: activityName,
    } as Activity;
}
